import type { NextPage } from 'next';
// import Numbers from 'components/landing-page/Numbers';
// import Banner from 'components/landing-page/Banner';
// import WhyPod from 'components/landing-page/WhyPod';
// import HowPodWorks from 'components/landing-page/HowPodWorks';

// import FaqLanding from 'components/landing-page/FaqLanding';
// import OurPartners from 'components/landing-page/OurPartners';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// import BecomePodInvestor from 'components/landing-page/BecomePodInvestor';
import { MetaTags } from 'components/common';
import RaiseFundPage from 'components/v2/raiseFundPage';
// import { useUser } from 'context/user.context';

const Home: NextPage = () => {
  // const [{ user }] = useUser();

  return (
    <>
      <MetaTags
        title="Raise funds for your startup"
        description="Raise seed funding for your startup with POD. Register Now!"
        imageUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}pod-logo.png`}
        url={process.env.NEXT_PUBLIC_FRONTEND_URL!}
        keywords="Raise funding"
      />
      <RaiseFundPage />
      {/* <Banner userType={2} />
      <Numbers />
      <WhyPod userType={2} />
      <HowPodWorks userType={2} />
      <FaqLanding userType={2} />
      <OurPartners /> */}
      {/* <BecomePodInvestor /> */}
      {/* <RaiseFundsWithPod /> */}
    </>
  );
};

export default Home;
